import i18next from 'i18next';

i18next.addResources('es', 'NotificationTable', {
  notificationDate: 'Fecha de notificación',
  fileNumber: 'N° expediente',
  cover: 'Carátula',
  searchBar: 'N° expediente, carátula',
  filterTitle: 'Por fecha de notificación'
});
